import { useState, useEffect } from "react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Tooltip from '@mui/material/Tooltip';
import { CssBaseline, Grid, useMediaQuery } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Archive from "../../../assets/Archive.svg";
import User from "../../../assets/User.svg";
import LogOut from "../../../assets/Logout.svg";
import MenuIcon from "@mui/icons-material/Menu";
//import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import HomeOutlinedIcon from "@mui/icons-material/Home";
import xpay from "../../../assets/xpay.png";
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { apiURL } from "../../../constants/apiUrlConstants";
import { clearSessionStorage, postRequest } from "../../../services/httpservice";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../../components/LanguageSwitcher";

function Header() {
  const { t } = useTranslation();
  const location = useLocation();
  const [activePages, setActivePages] = useState<string[]>([]);
  useEffect(() => {
    if (location.pathname.includes("/verification")) {
      setActivePages(["verification"]);
    } else if (location.pathname.includes("/deals")) {
      setActivePages(["verification", "deals"]);
    } else if (location.pathname.includes("/installments")) {
      setActivePages(["verification", "deals", "installments"]);
    } else if (location.pathname.includes("/payment-status")) {
      setActivePages(["verification", "deals", "installments", "payment"]);
    }
  }, [location.pathname]);

  const navigate = useNavigate();
  const [open, setState] = useState(false);
  const toggleDrawer = (open: boolean) => {
    setState(open);
  };

  const handleLogout = async () => {
    const accessToken = sessionStorage.getItem('accessToken');
    if (!accessToken) return;
    const civilId = sessionStorage.getItem('civilId');
    try {
      await postRequest(
        process.env.REACT_APP_API_URL + apiURL.LOG_OUT,
        { civilId }
      );
    } catch (_) {
      // proceed with logout even if API errors
    }
    clearSessionStorage();
    navigate('/');
  };
const isMobile = useMediaQuery("(max-width:700px)");
  return (
    <Box sx={{ display: 'flex', py: { sx: '15px', sm: 10, md: 5, lg: 5 } }}>
      <CssBaseline />
      <AppBar position="fixed" sx={{ top: 0, background: '#fff', py: "10px", px: "16px" }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} alignItems="center">

              {/* Logo */}
              <Grid item xs={6} sm={6} md={3}>
                {/* <Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 1, flexGrow: 1 }}>
                  <Link to={`/home/deals`}>
                    <img src={xpay} alt="Logo" style={{ width: '88px' }} />
                  </Link>
                </Box>
                <Box sx={{ display: { xs: 'flex', md: 'none' }, mr: 1, flexGrow: 1 }}>
                  <Link to={`/home/deals`}>
                    <img src={xpay} alt="Logo" style={{ width: '88px' }} />
                  </Link>
                </Box> */}
              </Grid>

              {/* Center (stepper placeholder) */}
              <Grid item xs={12} sm={12} md={6} sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block' }, textAlign: 'center' }} />

              {/* Nav icons + language switcher */}
              <Grid item xs={6} sm={6} md={3} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 1 }}>
                {/* Language Switcher — visible on all screen sizes */}
                <LanguageSwitcher />
                {/* Desktop icon buttons */}
                <Box sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center', gap: 1 }}>
                  <Tooltip title={t('header.home')}>
                    <IconButton sx={{ p: 0 }} onClick={() => navigate('/home/deals')}>
                      <span style={{ color: '#f2f2f2', background: '#2A92BD', padding: '10px 12px 5px', borderRadius: '5px', display: 'flex', alignItems: 'center' }}>
                        <HomeOutlinedIcon style={{ width: '22px', height: '27px', fontSize: '22px', color: '#f2f2f2' }} />
                      </span>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t('header.profile')}>
                    <IconButton sx={{ p: 0 }}>
                      <Link to="/home/profile" style={{ color: '#f2f2f2', background: '#2A92BD', padding: '10px 12px 5px', borderRadius: '5px' }}>
                        <img src={User} alt="profile" style={{ width: '18px' }} />
                      </Link>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t('header.transactionHistory')}>
                    <IconButton sx={{ p: 0 }}>
                      <Link to="/home/transactions" style={{ color: '#f2f2f2', background: '#2A92BD', padding: '10px 12px 5px', borderRadius: '5px' }}>
                        <img src={Archive} alt="transactions" style={{ width: '18px' }} />
                      </Link>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t('header.logout')}>
                    <IconButton sx={{ p: 0 }}>
                      <Link to="/" style={{ color: '#f2f2f2', background: '#C62828', padding: '10px 12px 5px', borderRadius: '5px' }} onClick={(e) => { e.preventDefault(); handleLogout(); }}>
                        <img src={LogOut} alt="logout" style={{ width: '18px' }} />
                      </Link>
                    </IconButton>
                  </Tooltip>
                </Box>
                {/* Mobile hamburger */}
                <Box sx={{ display: { xs: 'flex', sm: 'none' } }}>
                  <IconButton edge="start" aria-label="open drawer" onClick={() => toggleDrawer(true)} sx={{ color: "#404041" }}>
                    <MenuIcon />
                  </IconButton>

                  <Drawer anchor="right" open={open}>
                    <Box sx={{ p: 2, height: 1, backgroundColor: "#2A92BD" }}>
                      <IconButton sx={{ mb: 2, color: "white", width: '20%', marginLeft: '50vw' }} onClick={() => toggleDrawer(false)}>
                        <CloseIcon />
                      </IconButton>
                      <Divider sx={{ mb: 2, backgroundColor: 'rgba(0,0,0,0.12)' }} />
                      <Box sx={{ mb: 2 }}>

                        <ListItemButton component={Link} to="deals" onClick={() => toggleDrawer(false)}>
                          <ListItemIcon style={{ color: 'white' }}>
                            <HomeOutlinedIcon style={{ width: '22px', height: '27px', fontSize: '22px', color: '#ffffff' }} />
                          </ListItemIcon>
                          <ListItemText style={{ color: 'white' }} primary={t('header.home')} />
                        </ListItemButton>

                        <ListItemButton component={Link} to="transactions" onClick={() => toggleDrawer(false)}>
                          <ListItemIcon>
                            <img src={Archive} alt="transactions" style={{ width: '18px' }} />
                          </ListItemIcon>
                          <ListItemText style={{ color: 'white' }} primary={t('header.transactionDetails')} />
                        </ListItemButton>
                        <ListItemButton component={Link} to="profile" onClick={() => toggleDrawer(false)}>
                          <ListItemIcon style={{ color: 'white' }}>
                            <span className="step-icon">
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_1873_11774)">
                                  <path d="M16.687 2.86302C14.8407 1.01679 12.386 0 9.775 0C7.16405 0 4.70926 1.01679 2.86302 2.86302C1.01679 4.70926 0 7.16405 0 9.775C0 12.386 1.01679 14.8407 2.86302 16.687C4.70926 18.5332 7.16405 19.55 9.775 19.55C12.386 19.55 14.8407 18.5332 16.687 16.687C18.5332 14.8407 19.55 12.386 19.55 9.775C19.55 7.16405 18.5332 4.70926 16.687 2.86302ZM4.24241 16.3921C4.56518 13.6148 6.95299 11.4706 9.775 11.4706C11.2627 11.4706 12.6616 12.0502 13.7139 13.1023C14.6028 13.9915 15.1635 15.1523 15.3077 16.3919C13.8087 17.6474 11.8787 18.4045 9.775 18.4045C7.67132 18.4045 5.74141 17.6475 4.24241 16.3921ZM9.775 10.2908C8.13803 10.2908 6.80608 8.95883 6.80608 7.32185C6.80608 5.68473 8.13803 4.35293 9.775 4.35293C11.412 4.35293 12.7439 5.68473 12.7439 7.32185C12.7439 8.95883 11.412 10.2908 9.775 10.2908ZM16.2937 15.4236C16.0018 14.2468 15.3931 13.1617 14.5238 12.2924C13.8198 11.5884 12.9869 11.0603 12.0785 10.7293C13.1705 9.98874 13.8894 8.73763 13.8894 7.32185C13.8894 5.05321 12.0436 3.20742 9.775 3.20742C7.50636 3.20742 5.66057 5.05321 5.66057 7.32185C5.66057 8.73837 6.38009 9.98993 7.47295 10.7303C6.63723 11.0349 5.86387 11.5058 5.19849 12.1257C4.23495 13.023 3.56584 14.1672 3.2556 15.4227C1.9417 13.9081 1.14551 11.9328 1.14551 9.775C1.14551 5.01667 5.01667 1.14551 9.775 1.14551C14.5333 1.14551 18.4045 5.01667 18.4045 9.775C18.4045 11.9333 17.608 13.909 16.2937 15.4236Z" fill="white" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1873_11774">
                                    <rect width="19.55" height="19.55" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                          </ListItemIcon>
                          <ListItemText style={{ color: 'white' }} primary={t('header.profile')} />
                        </ListItemButton>

                        <ListItemButton onClick={handleLogout}>
                          <ListItemIcon>
                            <img src={LogOut} alt="logout" style={{ width: '18px' }} />
                          </ListItemIcon>
                          <ListItemText style={{ color: 'white' }} primary={t('header.logout')} />
                        </ListItemButton>

                      </Box>
                    </Box>
                  </Drawer>
                </Box>
              </Grid>
            </Grid>
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
}
export default Header;